<template>
  <div>
    <h4>
      {{ JSON.parse(element.info).name ?
      JSON.parse(element.info).name : val.widget_master.name }}
    </h4>
    <iframe
      :src="element.info ? JSON.parse(element.info).url : ''"
      class="analytic-box-widget"/>
  </div>
</template>

<script>

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },

  methods: {
  },
};
</script>

<style lang="scss">
  .analytic-box-widget {
    border: none;
    width: 100%;
    height: 700px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jAnalytic2Widget.vue